// Yard-local date/time formatting.
// Every timestamp is STORED in UTC; we display it in the yard's configured timezone
// so the calendar date matches the staff's actual day (kills the UTC off-by-one).
// The timezone is loaded once from /auth/me (yard_timezone) via setYardTz().

let YARD_TZ = "America/Chicago"; // sensible default until /auth/me loads

export function setYardTz(tz) { if (tz) YARD_TZ = tz; }
export function getYardTz() { return YARD_TZ; }

function toDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

// "07/20/2026"
export function formatDate(iso, extra = {}) {
  const d = toDate(iso);
  return d ? d.toLocaleDateString("en-US", { timeZone: YARD_TZ, year: "numeric", month: "2-digit", day: "2-digit", ...extra }) : "—";
}

// "07/20/2026, 11:32 AM"
export function formatDateTime(iso, extra = {}) {
  const d = toDate(iso);
  return d ? d.toLocaleString("en-US", { timeZone: YARD_TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", ...extra }) : "—";
}

// "11:32 AM"
export function formatTime(iso, extra = {}) {
  const d = toDate(iso);
  return d ? d.toLocaleTimeString("en-US", { timeZone: YARD_TZ, hour: "2-digit", minute: "2-digit", ...extra }) : "—";
}

// Short label for compact rows: "Jul 20, 11:32 AM"
export function formatShort(iso) {
  const d = toDate(iso);
  return d ? d.toLocaleString("en-US", { timeZone: YARD_TZ, month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
}
